<template>
  <div class="banner-container">
    <div class="banner-header">
      <span>{{ title }}</span>
      <p>{{ description }}</p>
    </div>

    <img :src="require(`@/assets/${imageName}`)" alt="">
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    imageName: String
  },
}
</script>

<style scoped>
.banner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  text-align: center;
}

.banner-header {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.banner-header>span,
p {
  margin-bottom: 0;
}

.banner-header>span {
  color: #1E2F5B;
  font-size: 2rem;
  font-weight: 700;
}

.banner-header>p {
  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 600;
}
</style>
